import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { BinderSessionWizardService } from '../../services/sections/binder/binder-session-wizard.service';
import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../../services/ui/global-settings.service';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class BinderSessionConfirmationResolver implements Resolve<boolean> {
	constructor(
		private router: Router,
		private binderSessionWizardService: BinderSessionWizardService,
	) {}

	resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
		GlobalSettingsService.isGlobalLoaderLoading = true;
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		const token = route.paramMap.get('token');

		if (!token) {
			this.router.navigate(['/404']);
			return of(false);
		}

		return this.binderSessionWizardService.confirmStatusRequest(token).pipe(
			map(response => {
				if (response.binderSessionStatus.isRedirectRequired && !response.binderSessionStatus.isConfirmationRequired){
					this.router.navigate([`${token}/binder-session`]);
					return false;
				}

				if (response.binderSessionStatus.isRedirectRequired) {
					return true;
				}

				if (!response.binderSessionStatus.isRedirectRequired) {
					return true;
				}

				this.router.navigate(['/404']);
				return false;
			}),
			catchError(() => {
				this.router.navigate(['/404']);
				return of(false);
			})
		);
	}
}